export default __webpack_public_path__ + "static/media/kotlin.9327ed0d.png";